import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { RelatedCompaniesModel } from './related-companies.model';
import { RelatedCompaniesService } from './related-companies.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { RelatedCompaniesListComponent } from './related-companies-list.component';

@Component({
    selector: 'app-related-companies-form',
    templateUrl: './related-companies-form.component.html',
    styleUrls: ['./related-companies-form.component.css'],
    standalone: false
})
export class RelatedCompaniesFormComponent implements OnInit {

  uid: number = this.data.uid;
  ready: boolean = false;
  saved: boolean = false;

  nameOrBusinessNameFormControl: UntypedFormControl;
  accountsTypeGroupFormControl: UntypedFormControl;
  relatedCompaniesModel: RelatedCompaniesModel;
  submitted: boolean = false;

  accountsTypeGroup_options = [
    { id: '5523', name: '5523 - Con emp. del grupo' },
    { id: '5524', name: '5524 - Con emp. asociadas' },
    { id: '5525', name: '5525 - Con otras partes vinc' }
  ]

  constructor(
    public RelatedCompaniesService: RelatedCompaniesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public dialogRef: MatDialogRef<RelatedCompaniesListComponent>,
    public snackBar: MatSnackBar

  ) {
    this.relatedCompaniesModel = new RelatedCompaniesModel();
    this.nameOrBusinessNameFormControl = new UntypedFormControl();
    this.accountsTypeGroupFormControl = new UntypedFormControl();
  }

  ngOnInit() {
    if (this.uid != null) {
      this.relatedCompaniesModel.uid = this.uid;
      this.ready = false;

      this.RelatedCompaniesService.loadData(this.uid).then(relatedCompanies => {
        this.relatedCompaniesModel = relatedCompanies;
        this.ready = true;
      });

    } else {
      // CREATE: dejamos uid undefined para que JSON.stringify lo omita y el backend use el default 0.
      // Si lo asignamos como null, ASP.NET no puede deserializarlo en `int Uid` y revienta el binder.
      this.ready = true;
    }
  }

  // SAVE
  onSubmit() {
    if (this.nameOrBusinessNameFormControl.invalid || this.accountsTypeGroupFormControl.invalid) {
      this.nameOrBusinessNameFormControl.markAsTouched();
      this.accountsTypeGroupFormControl.markAsTouched();
    }

    if (this.isDataValid()) {
      this.submitted = true;
      this.save(this.relatedCompaniesModel);
    } else {
      this.displayInfo("Compruebe los campos marcados en rojo");
      return;
    }
  }

  private isDataValid(): boolean {
    if (!this.nameOrBusinessNameFormControl.invalid || !this.accountsTypeGroupFormControl.invalid) {
      return true;
    }
    return false;
  }

  save(relatedCompaniesModel) {
    const noError = true;
    const mensajeError = '';
    if (noError) {
      if (relatedCompaniesModel.uid == null) {
        this.RelatedCompaniesService.addData(relatedCompaniesModel)
          .then(relatedCompaniesModel => {
            this.relatedCompaniesModel = relatedCompaniesModel;
            if (this.data != null) {
              this.saved = true;
              this.closeDialog();
            } else {
              this.dummy.redirectTo('/partnersequity/related-companies');
            }
          },
            error => this.displayInfo(error.error['message'])
          )
      } else {
        this.RelatedCompaniesService.editData(relatedCompaniesModel.uid, relatedCompaniesModel)
          .then(relatedCompaniesModel => {
            this.relatedCompaniesModel = relatedCompaniesModel;
            if (this.data != null) {
              this.saved = true;
              this.closeDialog();
            } else {
              this.dummy.redirectTo('/partnersequity/related-companies');
            }
          },
            error => this.displayInfo(error.error['message'])
          )
      }
    } else {
      this.displayInfo(mensajeError);
    }
  }

  closeDialog() {
    this.dialogRef.close(this.saved);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }
}
